<template>
  <div v-if="showDevTools" class="dev-tools" :class="{ expanded: isExpanded }">
    <div class="dt-header" @click="toggleExpanded()">
      <div class="heading">Dev tools</div>
      <div class="ml-auto action-bar">
        <btn class="btn-sm" :icon="isExpanded ? 'chevron-up' : 'chevron-down'" />
      </div>
    </div>

    <div class="dt-body">
      <div v-if="userSelect" class="dev-select-user">
        <SelectInput
          id="dt-u-select"
          label="Uživatel"
          :data="userSelect"
          valueType="object"
          v-model="user"
          @input="userChange()"
        />

        <div class="row">
          <div class="col-auto ml-auto">
            <btn type="button" class="btn-link" @click="editUserDef()">Změna definice uživatelů</btn>
          </div>
        </div>
      </div>

      <div v-else>
        <TextareaInput id="dt-u-def" label="Definice testovacích uživatelů" v-model="userDefinitionRaw" />
        <btn type="button" class="btn-info" @click="updateUserDef()">Uložit</btn>
      </div>
    </div>
  </div>
</template>

<script>
import { DEV_TOOLS } from '@/config';
import { default as devStorage, devStoragePersistent } from '@/services/_devTools/devStorage';
import SelectInput from '@/components/form/SelectInput';
import TextareaInput from '@/components/form/TextareaInput';

const userDefUtils = (function() {
  return {
    findUser(userObj) {
      return ({ key }) => key === userObj.key;
    },
    mapUsers(userDef) {
      const identityNameMap = {};

      return userDef.map(user => {
        const { label, fakeIdentity } = user;
        const { identityName } = fakeIdentity;

        const identityNameOrdinal = identityNameMap[identityName] === undefined ? 0 : identityNameMap[identityName] + 1;
        identityNameMap[identityName] = identityNameOrdinal;

        const key = label || (identityNameOrdinal ? `${identityName} (${identityNameOrdinal + 1})` : identityName);

        const data = {
          key,
          fakeIdentity,
        };

        return {
          key,
          label: key,
          data,
        };
      });
    },
  };
})();

export default {
  components: {
    SelectInput,
    TextareaInput,
  },

  data() {
    return {
      showDevTools: devStorage.showDevTools,
      isExpanded: false,
      user: devStorage.user,
      userDefinitionRaw: '',
      userSelect: null,
    };
  },

  created() {
    if (DEV_TOOLS) {
      window.addEventListener('keyup', this.toggleDevTools);
    }

    this.userDefinitionRaw = devStoragePersistent.userDefinitionRaw || '';
    if (this.userDefinitionRaw) {
      this.updateUserDef();
    }
    if (this.userSelect && this.user) {
      const userItem = this.userSelect.find(userDefUtils.findUser(this.user));
      this.user = (userItem && userItem.data) || this.user;
    }
  },
  beforeDestroy() {
    if (DEV_TOOLS) {
      window.removeEventListener('keyup', this.toggleDevTools);
    }
  },

  methods: {
    toggleDevTools(e) {
      if (e.altKey && e.keyCode === 85) {
        this.showDevTools = !this.showDevTools;
        devStorage.showDevTools = this.showDevTools;
      }
    },

    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    updateUserDef() {
      try {
        this.userSelect = userDefUtils.mapUsers(JSON.parse(this.userDefinitionRaw));
        devStoragePersistent.userDefinitionRaw = this.userDefinitionRaw;
        this.isExpanded = false;
      } catch (err) {
        this.$notify({
          title: 'Definice uživatelů',
          text: err,
          type: 'danger',
        });
      }
    },

    userChange() {
      devStorage.user = this.user;
      this.$store.commit('user/userInfo', {});
      window.location.reload();
    },

    editUserDef() {
      this.userSelect = null;
      this.isExpanded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.dev-tools {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 8rem;
  left: 2rem;
  background-color: #eee;
  border: 1px #ccc solid;
  border-radius: 0.25rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);

  &.expanded {
    min-width: 50%;
  }

  & ::v-deep textarea {
    min-height: 30vh;
  }
}

.dt {
  &-header {
    display: flex;
    margin-left: 1rem;
    margin-bottom: 1rem;
    cursor: pointer;

    .heading {
      align-self: center;
    }

    .btn {
      box-shadow: none;
    }
  }

  &-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 1rem;
    padding-bottom: 1rem;
  }
}
</style>
